import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Landing  from './pages/Landing';
import Login    from './pages/Login';
import Register from './pages/Register';

import SalesOrders       from './components/SalesOrders';
import InvoiceGenerator  from './components/InvoiceGenerator';
import Quotes            from './components/Quotes';
import Customers         from './components/Customers';
import SalesOrdersList   from './components/SalesOrdersList';
import PaymentsReceived  from './components/PaymentsReceived';
import Reports           from './components/Reports';
import PurchaseOrder    from './components/PurchaseOrder';
import SimpleInvoice    from './components/SimpleInvoice';
import Settings         from './components/Settings';



// Guard: redirect to /login if not authenticated
function PrivateRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) return (
        <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#0b1628' }}>
            <div style={{ color:'white', fontSize:'18px', fontWeight:'600', fontFamily:'Inter,sans-serif' }}>🔄 Loading…</div>
        </div>
    );
    return user ? children : <Navigate to="/login" replace />;
}

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Public */}
                    <Route path="/"         element={<Landing />} />
                    <Route path="/login"    element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    {/* Protected */}
                    <Route path="/sales" element={<PrivateRoute><SalesOrders /></PrivateRoute>}>
                        <Route index                    element={<InvoiceGenerator />} />
                        <Route path="invoices"          element={<InvoiceGenerator />} />
                        <Route path="customers"         element={<Customers />} />
                        <Route path="quotes"            element={<Quotes />} />
                        <Route path="orders-list"       element={<SalesOrdersList />} />
                        <Route path="payments-received" element={<PaymentsReceived />} />
                        <Route path="reports"           element={<Reports />} />
                        <Route path="purchase-order"    element={<PurchaseOrder />} />
                        <Route path="simple-invoice"    element={<SimpleInvoice />} />
                        <Route path="settings"          element={<Settings />} />
                    </Route>

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;